import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "./TechnologyPractices.css";
import Testimonial from "../../../Testimonial/Testimonial";

const TechnologyPractices = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    // Set initial container width
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed (pixels per frame)

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

    const [activeTab, setActiveTab] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const canvasRef = useRef(null);

  useEffect(() => {
    setIsVisible(true);
    startParticles();
    
    return () => {
      if (canvasRef.current) {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
    };
  }, []);

  const startParticles = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    const particles = [];
    const particleCount = 50;
    
    // Set canvas size
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
    
    // Create particles
    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        radius: Math.random() * 3 + 1,
        speedX: (Math.random() - 0.5) * 0.5,
        speedY: (Math.random() - 0.5) * 0.5,
        color: `rgba(${Math.random() * 70 + 100}, ${Math.random() * 70 + 100}, ${Math.random() * 200 + 55}, ${Math.random() * 0.5 + 0.3})`
      });
    }
    
    // Animation loop
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      // Update and draw particles
      particles.forEach(particle => {
        particle.x += particle.speedX;
        particle.y += particle.speedY;
        
        // Bounce off walls
        if (particle.x <= 0 || particle.x >= canvas.width) particle.speedX *= -1;
        if (particle.y <= 0 || particle.y >= canvas.height) particle.speedY *= -1;
        
        // Draw particle
        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.radius, 0, Math.PI * 2);
        ctx.fillStyle = particle.color;
        ctx.fill();
        
        // Draw connections
        particles.forEach(otherParticle => {
          const dx = particle.x - otherParticle.x;
          const dy = particle.y - otherParticle.y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          
          if (distance < 100) {
            ctx.beginPath();
            ctx.strokeStyle = `rgba(100, 150, 255, ${0.2 * (1 - distance/100)})`;
            ctx.lineWidth = 0.5;
            ctx.moveTo(particle.x, particle.y);
            ctx.lineTo(otherParticle.x, otherParticle.y);
            ctx.stroke();
          }
        });
      });
      
      requestAnimationFrame(animate);
    };
    
    animate();
    
    // Handle resize
    const handleResize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  };

  const practices = [
    {
      title: "AI & Machine Learning",
      description: "Intelligent solutions powered by cutting-edge artificial intelligence and machine learning algorithms that learn and adapt.",
      icon: "🤖",
      features: ["Predictive Analytics", "Computer Vision", "Natural Language Processing", "MLOps", "Neural Networks"]
    },
    {
      title: "Generative AI",
      description: "Creating novel content, designs, and solutions through advanced generative models and algorithms.",
      icon: "🎨",
      features: ["Content Generation", "Image Synthesis", "Code Generation", "Creative Design", "Personalized Experiences"]
    },
    {
      title: "AI-Powered Analytics",
      description: "Transforming data into actionable intelligence with AI-driven insights and predictive modeling.",
      icon: "📊",
      features: ["Predictive Modeling", "Pattern Recognition", "Anomaly Detection", "Trend Analysis", "Data Visualization"]
    },
    {
      title: "Intelligent Automation",
      description: "Streamlining processes and operations with AI-driven automation and cognitive capabilities.",
      icon: "⚙️",
      features: ["Process Optimization", "Cognitive RPA", "Workflow Automation", "Decision Support Systems", "Smart Assistants"]
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Technology Practices | Our Comprehensive Tech Stack</title>
        <meta 
          name="description" 
          content="Explore our extensive technology practices and comprehensive tech stack. We utilize cutting-edge tools and frameworks to deliver innovative solutions across various domains." 
        />
        <meta 
          name="keywords" 
          content="technology practices, tech stack, web development, mobile development, blockchain, AI, frameworks, programming languages, software tools, development technologies" 
        />
      </Helmet>
      

        <div className={`ai-tech-container ${isVisible ? 'visible' : ''}`}>
      <canvas ref={canvasRef} className="ai-particles"></canvas>
      
      <div className="ai-tech-hero">
        <div className="ai-hero-content">
          <h1 className="ai-main-title">
            <span className="title-gradient">AI Technology</span> Practice
          </h1>
          <p className="ai-subtitle">
            Pioneering intelligent solutions with cutting-edge artificial intelligence
          </p>
          <div className="ai-pulse">
            <div className="pulse-ring"></div>
            <div className="pulse-ring delay-1"></div>
            <div className="pulse-ring delay-2"></div>
            <div className="ai-core"></div>
          </div>
        </div>
      </div>

      <div className="ai-tech-content">
        <div className="ai-tech-intro">
          <h2>Our <span className="highlight">AI</span> Expertise</h2>
          <p>
            At MK ETech, we harness the power of artificial intelligence to create transformative solutions that drive innovation, 
            enhance decision-making, and unlock new possibilities for businesses across industries. Our AI practice combines 
            advanced algorithms, deep learning, and data science to deliver intelligent systems that learn, adapt, and evolve.
          </p>
        </div>

        <div className="ai-practice-tabs">
          {practices.map((practice, index) => (
            <div 
              key={index} 
              className={`ai-practice-tab ${activeTab === index ? 'active' : ''}`}
              onClick={() => setActiveTab(index)}
            >
              <span className="ai-tab-icon">{practice.icon}</span>
              <span className="ai-tab-title">{practice.title}</span>
              <div className="ai-tab-indicator"></div>
            </div>
          ))}
        </div>

        <div className="ai-practice-details">
          <div className="ai-practice-info">
            <h3>{practices[activeTab].title}</h3>
            <p>{practices[activeTab].description}</p>
            <div className="ai-features-grid">
              {practices[activeTab].features.map((feature, idx) => (
                <div key={idx} className="ai-feature-item">
                  <span className="ai-feature-icon">✦</span>
                  <span>{feature}</span>
                </div>
              ))}
            </div>
            <button className="ai-cta-button">
              <span>Explore Capabilities</span>
              <div className="ai-button-icon">→</div>
            </button>
          </div>
          <div className="ai-practice-visual">
            <div className="ai-neural-network">
              <div className="neural-node main-node">
                <div className="node-pulse"></div>
                <div className="node-core"></div>
              </div>
              {[1, 2, 3, 4].map(i => (
                <div key={i} className={`neural-node connected-node node-${i}`}>
                  <div className="node-core"></div>
                  <div className="connection-line"></div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="ai-tech-stats">
          <div className="ai-stat-item">
            <div className="ai-stat-value">85%</div>
            <div className="ai-stat-label">AI Implementation Success Rate</div>
          </div>
          <div className="ai-stat-item">
            <div className="ai-stat-value">40+</div>
            <div className="ai-stat-label">AI Projects Deployed</div>
          </div>
          <div className="ai-stat-item">
            <div className="ai-stat-value">3x</div>
            <div className="ai-stat-label">Average ROI for Clients</div>
          </div>
          <div className="ai-stat-item">
            <div className="ai-stat-value">15</div>
            <div className="ai-stat-label">AI Research Papers Published</div>
          </div>
        </div>

        <div className="ai-innovation-section">
          <h2>Driving <span className="highlight">Innovation</span> Forward</h2>
          <p>
            Our AI Technology Practice is at the forefront of developing next-generation intelligent systems. 
            We combine research excellence with practical implementation to create AI solutions that are both 
            cutting-edge and business-ready.
          </p>
          <div className="ai-innovation-grid">
            <div className="ai-innovation-card">
              <div className="innovation-icon">🔬</div>
              <h4>Research & Development</h4>
              <p>Continuous exploration of emerging AI technologies and methodologies</p>
            </div>
            <div className="ai-innovation-card">
              <div className="innovation-icon">🛠️</div>
              <h4>Custom Solutions</h4>
              <p>Tailored AI implementations designed for specific business challenges</p>
            </div>
            <div className="ai-innovation-card">
              <div className="innovation-icon">📈</div>
              <h4>Scalable Platforms</h4>
              <p>Enterprise-grade AI systems that grow with your business needs</p>
            </div>
          </div>
        </div>
      </div>
    </div>


      <Testimonial />

      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnologyPractices;